
import { compile } from "path-to-regexp";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "Breadcrumb",
})
export default class extends Vue {
    private breadcrumbs: any[] = [];
    private showBack: boolean = false;

    @Watch("$route")
    private onRouteChange(route: Route) {
        if (route.path.startsWith("/redirect/")) {
            return;
        }
        this.getBreadcrumb();
    }

    created() {
        this.getBreadcrumb();
    }

    private getBreadcrumb() {
        let currentPath: string = this.$route.path;
        let parentRoute: string = this.$route.meta && typeof this.$route.meta.parentRoute === 'string' ? this.$route.meta.parentRoute
    : ''; // 提供一个默认值，避免 undefined 异常

        //console.log("currentPath", currentPath)
        //console.log("parentRoute", parentRoute)

        if (currentPath === "/home") {
            this.breadcrumbs = [{ n: "工作台" }];
            this.showBack = false;
            return;
        } else if (currentPath === "/chatroom") {
            this.breadcrumbs = [{ n: "接单系统" }];
            return;
        }
        //console.log("menuList", UserModule.menuList)
        //console.log("title", this.$route?.meta?.title)
        this.breadcrumbs = [];
        UserModule.menuList.find((ele: any) => {
            let flag: any = "";
            //console.log("ele.l", ele.l)
            //console.log("ele.n", ele.n)
            if (ele.l && ele.l.length > 0) {
                flag = ele.l.find((item: any) => {
                    //console.log("--item.u", item.u,"---length", (item.l) )
                    try {
                        if ((item.u === currentPath || parentRoute === item.u) && typeof item.l=='undefined' ) {
                            //console.log("----------------match-item", item)
                            this.breadcrumbs.push(ele);
                            this.breadcrumbs.push(item);
                            // if (parentRoute) {
                            //     this.breadcrumbs.push({
                            //         n: this.$route?.meta?.title,
                            //     });
                            //     this.showBack = true;
                            // } else {
                            //     this.showBack = false;
                            // }
                            return true;
                        }

                        if (item.l && item.l.length > 0) {
                            let h: any = item.l.find((element: any) => {
                                if (
                                    element.u === currentPath ||
                                    parentRoute === element.u
                                ) {
                                    this.breadcrumbs.push(ele);
                                    this.breadcrumbs.push(item);
                                    this.breadcrumbs.push(element);
                                    if (parentRoute) {
                                        this.breadcrumbs.push({
                                            n: this.$route?.meta?.title,
                                        });
                                        this.showBack = true;
                                    } else {
                                        this.showBack = false;
                                    }

                                    return true;
                                }
                            });

                            if (h) return true;
                        }
                    }
                    catch (e) {
                        console.log(e)
                    }

                });
            }

            if (flag) {
                return true;
            }
        });
    }

    private pathCompile(path: string) {
        const { params } = this.$route;
        const toPath = compile(path);
        return toPath(params);
    }
}
